import React from 'react';

import ms1 from '../../images/mission/respect.png';
import ms2 from '../../images/mission/flag.png';
import ms3 from '../../images/mission/empathy.png';
import ms4 from '../../images/mission/icon4.png';
import ms5 from '../../images/mission/justice.png';
import './style.css';

const Values = (props) => {
  return (
    <div className={`wpo-mission-area ${props.subclass}`}>
      <div className='container'>
        <div className='row'>
          <div className='col-12'>
            <div className='wpo-section-title'>
              <span>What Drives Us?</span>
              <h2>We Have Core Values That Drive Us</h2>
            </div>
          </div>
        </div>
        <div className='wpo-mission-wrap'>
          <div className='row'>
            <div className='col-lg-3 col-md-6 col-sm-12 col-12 custom-grid'>
              <div className='wpo-mission-item'>
                <div className='wpo-mission-icon-5'>
                  <img src={ms1} alt='' />
                </div>
                <div className='wpo-mission-content'>
                  <h2>Diginity</h2>
                  <p>
                    We believe that every human being has an inherent worth,
                    regardless of their social status, socioeconomic situation,
                    ethnicity, or of their political or religious affiliation.
                  </p>
                </div>
              </div>
            </div>
            <div className='col-lg-3 col-md-6 col-sm-12 col-12 custom-grid'>
              <div className='wpo-mission-item'>
                <div className='wpo-mission-icon-6'>
                  <img src={ms3} alt='' />
                </div>
                <div className='wpo-mission-content'>
                  <h2>Compassion</h2>
                  <p>
                    We share the suffering of our neighbors, but do not pity
                    them. Instead, we help them get back on their feet.
                  </p>
                </div>
              </div>
            </div>
            <div className='col-lg-3 col-md-6 col-sm-12 col-12 custom-grid'>
              <div className='wpo-mission-item'>
                <div className='wpo-mission-icon-7'>
                  <img src={ms2} alt='' />
                </div>
                <div className='wpo-mission-content'>
                  <h2>Tolerance</h2>
                  <p>
                    We welcome our differences as a source of strength and
                    inspiration. We live together as members of the same family
                    by respecting the liberties, convictions and opinions of one
                    another.
                  </p>
                </div>
              </div>
            </div>
            <div className='col-lg-3 col-md-6 col-sm-12 col-12 custom-grid'>
              <div className='wpo-mission-item'>
                <div className='wpo-mission-icon-8'>
                  <img src={ms4} alt='' />
                </div>
                <div className='wpo-mission-content'>
                  <h2>Humility</h2>
                  <p>
                    We recognize our limits and are open to any constructive
                    contribution by our partners, so that we may improve our
                    services.
                  </p>
                </div>
              </div>
            </div>
            <div className='col-lg-3 col-md-6 col-sm-12 col-12 custom-grid'>
              <div className='wpo-mission-item'>
                <div className='wpo-mission-icon-8'>
                  <img src={ms5} alt='' />
                </div>
                <div className='wpo-mission-content'>
                  <h2>Integrity</h2>
                  <p>
                    We use all goods and donations towards the common good and
                    are fully transparent with all our partners as to the use of
                    these goods.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Values;
